<template>
  <div>
    <!-- <Head v-if="tabName != '登录'" @labelName="labelName"></Head> -->
    <router-view></router-view>
    <!-- <Hooter v-if="tabName != '登录'"></Hooter>
    <SlideBar v-if="tabName != '登录'" id="content4"></SlideBar>
    <a ref="backer" id="backer" class="backer" href="#">
      <img src="../assets/ding.png" />
    </a> -->
  </div>
</template>

<script>
import Head from "../components/head.vue";
import Hooter from "../components/footer.vue";
import SlideBar from "../components/sidebar.vue";
export default {
  components: {
    Head,
    Hooter,
    SlideBar,
  },
  name: "IndexHome",
  data() {
    return {
      tabName: "首页",
    };
  },
  methods: {
    labelName(name) {
      this.tabName = name;
      console.log("子组件传递过来的值", name);
    },
  },
  watch: {
    $route(to, from) {
      switch (to.path) {
        case "/home":
          this.tabName = "首页";
          break;
        case "/cooperation":
          this.tabName = "合作案例";
          break;
        case "/equipment":
          this.tabName = "设备";
          break;
        case "/about":
          this.tabName = "关于我们";
          break;
        default:
          break;
      }
      // console.log(to);
      // console.log(from);
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      if (top > 600) {
        const backer = document.getElementById("backer");
        if (backer) backer.style = "display:flex";
        if (this.$refs.backer) {
          this.$refs.backer.classList.add("animate__backInUp");
          this.$refs.backer.classList.add("animate__animated");
        }
      } else {
        const backer = document.getElementById("backer");
        if (backer) backer.style = "display:none";
      }
    });
  },
};
</script>

<style lang="scss" scoped>
:root {
  --scroll-Height: 1.25rem;
  /* 滚动指定距离后，开始展示粘贴元素 */
}

/* 主要用于展示思路 */
a:not(.backer) {
  width: 200px;
  height: 200px;
  background-color: skyblue;
  display: block;
  position: sticky;
  top: 0;
  top: -100px;
  transform: translateY(calc(100vh));
  transform: translateY(calc(100vh + var(--scroll-Height)));
  top: -200px;
  float: right;
  margin-top: -200px;
  transform: translateY(calc(100vh + var(--scroll-Height) + 200px));
  top: calc(-200px - 200px);
  margin-right: 20px;
  top: calc(-200px - 200px - var(--scroll-Height) - 20px);
}

.backer {
  /* 主要代码 */
  position: fixed;
  right: 30px;
  float: right;
  margin: -200px 20px 0 0;
  transform: translateY(calc(100vh + var(--scroll-Height) + 200px));
  // top: calc(-100px - 100px - var(--scroll-Height) - 20px);
  top: 103.3%;
  display: none;
  flex-flow: column;

  & > img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
  }
}
</style>